import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon"]

  connect() {
    this.isOpen = false
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.isOpen = true
    this.menuTarget.classList.remove("opacity-0", "pointer-events-none")
    this.menuTarget.classList.add("opacity-100")
    this.openIconTarget.classList.add("hidden")
    this.closeIconTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.isOpen = false
    this.menuTarget.classList.add("opacity-0", "pointer-events-none")
    this.menuTarget.classList.remove("opacity-100")
    this.openIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  // Close menu when clicking a link
  navigate() {
    this.close()
  }

  // Close on escape key
  closeOnEscape(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close()
    }
  }
}
